import { createContext, useEffect } from "react";
import { useState } from "react";

import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";

export const FilterConditionContext = createContext(null);

export function FilterConditionProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlStartDate = searchParams.get("start_date");
  const urlEndDate = searchParams.get("end_date");
  const urlDivisions = searchParams.get("divisions");

  const [startDate, setStartDate] = useState(
    urlStartDate ? dayjs.utc(urlStartDate) : dayjs.utc("2025-03-14"),
  );
  const [endDate, setEndDate] = useState(
    urlEndDate ? dayjs.utc(urlEndDate) : null,
  );
  const [dateRangeError, setDateRangeError] = useState("");
  const [selectedDivisions, setSelectedDivisions] = useState(
    urlDivisions
      ? JSON.parse(urlDivisions)
      : ["open", "master", "senior", "junior"],
  );

  useEffect(() => {
    if (urlStartDate || urlEndDate || urlDivisions) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("start_date");
      newParams.delete("end_date");
      newParams.delete("divisions");
      setSearchParams(newParams);
    }
  }, [urlStartDate, urlEndDate, urlDivisions, searchParams, setSearchParams]);

  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);
  const [currentSelectedDivisions, setCurrentSelectedDivisions] =
    useState(null);

  const [isBeforeSearch, setIsBeforeSearch] = useState(true);

  useEffect(() => {
    if (urlStartDate || urlEndDate || urlDivisions) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("start_date");
      newParams.delete("end_date");
      newParams.delete("divisions");
      setSearchParams(newParams);
    }
  }, [urlStartDate, urlEndDate, urlDivisions, searchParams, setSearchParams]);

  return (
    <FilterConditionContext.Provider
      value={{
        startDate,
        setStartDate,
        currentStartDate,
        setCurrentStartDate,
        endDate,
        setEndDate,
        currentEndDate,
        setCurrentEndDate,
        dateRangeError,
        setDateRangeError,
        selectedDivisions,
        setSelectedDivisions,
        currentSelectedDivisions,
        setCurrentSelectedDivisions,
        isBeforeSearch,
        setIsBeforeSearch,
      }}
    >
      {children}
    </FilterConditionContext.Provider>
  );
}
